module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("\n            Invoices\n        ")]), _vm._v(" "), _c('div', [(_vm.dataMarkingInvoicesPercentage.length > 0) ? _c('apexchart', {
    key: _vm.componentKey,
    attrs: {
      "type": "heatmap",
      "height": "1400",
      "options": _vm.chartOptions,
      "series": _vm.dataMarkingInvoicesPercentage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dataMarkingInvoicesAmount.length > 0) ? _c('apexchart', {
    key: _vm.componentKey,
    attrs: {
      "type": "heatmap",
      "height": "1400",
      "options": _vm.chartOptions,
      "series": _vm.dataMarkingInvoicesAmount
    }
  }) : _vm._e(), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "info"
    },
    on: {
      "click": _vm.setupData
    }
  }, [_vm._v("Test\n            ")]), _vm._v(" "), _c('hr')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082d2d4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/DashboardInvoices.vue
// module id = 1772
// module chunks = 1